<template>
  <div class="avatar-wrapper" :style="style">
    <span v-show="!image">{{ initials }}</span>
    <img v-show="image" :src="image" :alt="alt" />
  </div>
</template>

<script>
export default {
  name: "Avatar",
  props: {
    userName: { type: String, default: "" },
    size: { type: Number, default: 48 },
    radius: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0 && value <= 50,
    },
    color: { type: String, default: "#fff" },
    image: { type: String, default: "" },
    alt: { type: String, default: "image" },
  },
  computed: {
    initials() {
      const words = this.userName.split(/[\s-]+/);
      return words
        .map((word) => word.substr(0, 1))
        .join("")
        .substr(0, 2)
        .toUpperCase();
    },
    style() {
      const fontSize = this.initials.length > 2 ? this.size / 3 : this.size / 2;
      return {
        width: this.size + "px",
        height: this.size + "px",
        "border-radius": this.radius + "%",
        "font-size": fontSize + "px",
        "background-color": !this.image
          ? this.stringToHslColor(this.userName, 80, 30)
          : this.color,
        "background-image": this.image ? "url(" + this.image + ")" : "none",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        display: "flex",
        color: "#fff",
        "background-repeat": "no-repeat",
      };
    },
  },
  methods: {
    stringToHslColor(str, s, l) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }

      var h = hash % 360;
      return "hsl(" + h + ", " + s + "%, " + l + "%)";
    },
  },
};
</script>